/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StatusButtonUpdateMutationVariables = {|
  id: string,
  published?: ?boolean,
|};
export type StatusButtonUpdateMutationResponse = {|
  +recipeUpdate: ?{|
    +recipe: ?{|
      +id: string,
      +name: string,
      +published: boolean,
    |}
  |}
|};
export type StatusButtonUpdateMutation = {|
  variables: StatusButtonUpdateMutationVariables,
  response: StatusButtonUpdateMutationResponse,
|};
*/


/*
mutation StatusButtonUpdateMutation(
  $id: ID!
  $published: Boolean
) {
  recipeUpdate(input: {id: $id, published: $published}) {
    recipe {
      id
      name
      published
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "published",
    "type": "Boolean"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "published",
            "variableName": "published"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeUpdatePayload",
    "kind": "LinkedField",
    "name": "recipeUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeNode",
        "kind": "LinkedField",
        "name": "recipe",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "published",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StatusButtonUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StatusButtonUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "StatusButtonUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation StatusButtonUpdateMutation(\n  $id: ID!\n  $published: Boolean\n) {\n  recipeUpdate(input: {id: $id, published: $published}) {\n    recipe {\n      id\n      name\n      published\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e8ff90a885b010d0f89f187c725f6456';

module.exports = node;
